import { generateUniqueId } from 'modules/shared/utils/common-utils';
import { FC } from 'react';
import reactStringReplace from 'react-string-replace';

const boldRegex = /<bold>(.*?)<\/bold>/g;
const linkRegex = /<link>(.*?)<\/link>/g;

interface NotificationMessageProps {
    message: string;
}

const NotificationMessage: FC<NotificationMessageProps> = (props) => {
    const { message } = props;

    let processedMessage = reactStringReplace(message, boldRegex, (match, i) => (
        <span key={generateUniqueId()} className="font-semibold">
            {match}
        </span>
    ));

    processedMessage = reactStringReplace(processedMessage, linkRegex, (match, i) => (
        <span key={generateUniqueId()} className="text-primary font-medium underline">
            {match}
        </span>
    ));

    return <>{processedMessage}</>;
};

export default NotificationMessage;
